import React from "react";
import {FormattedDate, FormattedTime } from 'react-intl'
export const DateColumnFormatter = (cellContent, row,props) => (
    <FormattedDate value={cellContent} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD"/>
    // <FormattedTime value={cellContent} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD"/>
    
);


